import PropTypes from 'prop-types';

const BaseLayout = ({ children }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
};

BaseLayout.propTypes = {
  children: PropTypes.node
};

export default BaseLayout;
